(function(){
  'use strict';

  var BOGO_URL   = '/discount/BOGO50?redirect=/collections/bogo-eligible';
  var PILL_RED   = '#e53935';
  var PILL_GREEN = '#27ae60';
  var _bogoTimer = null;

  function pill(color, text) {
    return '<span style="display:inline-flex;align-items:center;flex-shrink:0;' +
      'background:' + color + ';color:#fff;font-size:10px;font-weight:700;' +
      'padding:2px 9px;border-radius:20px;white-space:nowrap;">' + text + '</span>';
  }

  function htmlFirst() {
    return '<div style="display:flex;align-items:center;gap:5px;flex-wrap:wrap;margin-bottom:5px;">' +
        pill(PILL_RED, '\uD83D\uDD25 BOGO50') +
        '<span style="font-size:10px;color:#555;">add a 2nd single-pack &amp; save 50%</span>' +
      '</div>' +
      '<a href="' + BOGO_URL + '" style="display:inline-flex;align-items:center;' +
        'font-size:10px;font-weight:700;color:#fff;background:#1a1a1a;' +
        'padding:4px 14px;border-radius:4px;text-decoration:none;white-space:nowrap;">' +
        'Shop Now \u203a</a>';
  }

  function htmlConfirmed() {
    return '<div style="display:flex;align-items:center;gap:5px;">' +
        pill(PILL_GREEN, '\u2713 BOGO50') +
        '<span style="font-size:10px;color:#27ae60;font-weight:600;">50% off applies at checkout</span>' +
      '</div>';
  }

  // CRITICO: contar drawer y cart page POR SEPARADO.
  // Ademas: excluir items marcados como mystery gift (data-mystery-gift="true")
  function applyGroup(items) {
    // Filtrar mystery gifts por data-mystery-gift en el div padre del item
    var eligibleItems = items.filter(function(el) {
      var parentItem = el.closest('[data-mystery-gift]');
      return !parentItem || parentItem.getAttribute('data-mystery-gift') !== 'true';
    });
    var count = eligibleItems.length;
    // Aplicar estado a todos los items elegibles
    eligibleItems.forEach(function(el) {
      var prev = el.getAttribute('data-bogo-fixed');
      if (prev === String(count)) return;
      el.setAttribute('data-bogo-fixed', String(count));
      el.style.cssText = 'display:block;margin-top:8px;';
      el.innerHTML = count >= 2 ? htmlConfirmed() : htmlFirst();
    });
    // Ocultar el badge en items que son mystery gift (por si quedaron del render anterior)
    items.filter(function(el) {
      var parentItem = el.closest('[data-mystery-gift]');
      return parentItem && parentItem.getAttribute('data-mystery-gift') === 'true';
    }).forEach(function(el) {
      el.style.cssText = 'display:none !important;';
    });
  }

  function applyBogo() {
    // Drawer: clase savvy-cd__item-bogo
    applyGroup(Array.from(document.querySelectorAll('.savvy-cd__item-bogo')));
    // Cart page: clase savvy-item-bogo
    applyGroup(Array.from(document.querySelectorAll('.savvy-item-bogo')));
  }

  function scheduleApplyBogo(delay) {
    if (_bogoTimer) clearTimeout(_bogoTimer);
    _bogoTimer = setTimeout(function() { _bogoTimer = null; applyBogo(); }, delay || 200);
  }

  // =============================================
  // CHECKOUT BUTTON FIX (drawer)
  // =============================================
  function fixCheckoutBtn() {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn && !btn._savvyCheckout) {
      btn._savvyCheckout = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/checkout';
      });
    }
  }

  // =============================================
  // OBSERVERS: solo contenedores especificos
  // =============================================
  function observe(el) {
    if (!el || el._savvyBogoObs) return;
    el._savvyBogoObs = true;
    new MutationObserver(function(muts) {
      var changed = muts.some(function(m) {
        return m.type === 'childList' &&
          (m.addedNodes.length > 0 || m.removedNodes.length > 0);
      });
      if (changed) {
        scheduleApplyBogo(200);
        setTimeout(fixCheckoutBtn, 300);
      }
    }).observe(el, { childList: true, subtree: true });
  }

  function initAll() {
    applyBogo();
    fixCheckoutBtn();
    observe(document.getElementById('CartDrawer'));
    observe(document.querySelector('cart-items'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // =============================================
  // TOAST: al agregar un 1-Pack
  // =============================================
  var TOAST_SHOWN = false;
  var origFetch = window.fetch;
  window.fetch = function() {
    var url  = typeof arguments[0] === 'string' ? arguments[0] : '';
    var opts = arguments[1] || {};
    var body = opts.body || null;
    var result = origFetch.apply(this, arguments);

    if (url.indexOf('/cart/add.js') !== -1 && body && !TOAST_SHOWN) {
      try {
        var data = typeof body === 'string' ? JSON.parse(body) : null;
        if (data && data.items && data.items.length > 0) {
          // No mostrar toast si es un mystery gift
          var isMysteryGift = data.items[0] && data.items[0].properties &&
            data.items[0].properties['_mystery_gift'] === 'true';
          if (!isMysteryGift) {
            result.then(function(r) { return r.clone().json(); })
            .then(function(res) {
              var handle = res && res.items && res.items[0] && res.items[0].handle;
              if (!handle) return;
              fetch('/products/' + handle + '.js')
              .then(function(r2) { return r2.json(); })
              .then(function(p) {
                if (p.tags && p.tags.some(function(t) { return t.toLowerCase() === '1-pack'; })) {
                  TOAST_SHOWN = true;
                  showBogoToast();
                  setTimeout(function() { TOAST_SHOWN = false; }, 30000);
                }
              }).catch(function() {});
            }).catch(function() {});
          }
        }
      } catch(e) {}
    }

    return result;
  };

  function showBogoToast() {
    var ex = document.getElementById('savvy-bogo-toast');
    if (ex) ex.remove();
    var t = document.createElement('div');
    t.id = 'savvy-bogo-toast';
    t.style.cssText =
      'position:fixed;top:16px;right:16px;z-index:99999;' +
      'background:#1a1a1a;color:#fff;padding:12px 16px;border-radius:8px;' +
      'font-size:13px;font-weight:600;box-shadow:0 4px 20px rgba(0,0,0,0.35);' +
      'max-width:280px;cursor:pointer;animation:_bToastIn 0.3s ease;';
    t.innerHTML =
      '<style>@keyframes _bToastIn{from{opacity:0;transform:translateX(20px);}to{opacity:1;transform:translateX(0);}}</style>' +
      '<div style="display:flex;align-items:flex-start;gap:10px;">' +
        '<span style="font-size:22px;flex-shrink:0;">\uD83D\uDD25</span>' +
        '<div><div>BOGO50 Available!</div>' +
        '<div style="font-weight:400;font-size:11px;margin-top:3px;color:#ddd;">' +
          'Add a 2nd single-pack &amp; get it 50% off &mdash; automatically.' +
        '</div>' +
        '<a href="' + BOGO_URL + '" style="display:inline-block;margin-top:6px;' +
          'color:#ffd700;font-size:11px;text-decoration:none;font-weight:600;">' +
          'Shop Eligible Items \u203a</a>' +
        '</div></div>';
    document.body.appendChild(t);
    setTimeout(function() {
      if (t.parentNode) {
        t.style.opacity = '0';
        t.style.transition = 'opacity 0.3s';
        setTimeout(function() { if (t.parentNode) t.remove(); }, 300);
      }
    }, 5000);
    t.addEventListener('click', function() { t.remove(); });
  }

})();
